"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Digatag = exports.checkValidUUID = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const checkValidUUID = (str) => {
    const regex = new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$", "i");
    const match = str.match(regex);
    return (match === null || match === void 0 ? void 0 : match.length) == 1;
};
exports.checkValidUUID = checkValidUUID;
class Digatag {
    constructor() {
        this.className = "Digatag";
    }
    setFromAny(element) {
        Object.assign(this, element);
        // dates... 
        const { updateTimestamp, timeStamp, expiryDate, activationTimeStamp } = element;
        this.timeStamp = timeStamp ? (0, obejct_diff_1.isDate)(timeStamp) ? timeStamp : (0, obejct_diff_1.firestoreTimestampToDate)(timeStamp) : this.timeStamp;
        this.expiryDate = expiryDate ? (0, obejct_diff_1.isDate)(expiryDate) ? expiryDate : (0, obejct_diff_1.firestoreTimestampToDate)(expiryDate) : this.expiryDate;
        this.activationTimeStamp = activationTimeStamp ? (0, obejct_diff_1.isDate)(activationTimeStamp) ? activationTimeStamp : (0, obejct_diff_1.firestoreTimestampToDate)(activationTimeStamp) : this.activationTimeStamp;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
    }
    searchFilter(filter) {
        const str = `${this.identifier}`.toLowerCase();
        return str.includes(filter);
    }
}
exports.Digatag = Digatag;
Digatag.className = "Digatag";
